import React, { Fragment, Component } from 'react';
import { groupCoursesToSems } from '../utils';
import { Link } from 'react-router-dom';
import RegisterCoursesLoader from '../loaderComponents/RegisterCoursesLoader';
import FETCH from '../Fetch';

class RegisteredCourses extends React.Component {
  state = {
    courses: null,
    semester: 'first'
  };

  removeCourse = id => {
    let { courses, semester } = this.state;
    let indexOfCourse = courses[semester].findIndex(course => (course.course_id === id));
    courses[semester].splice(indexOfCourse, 1);
    console.log(courses)
    this.setState({ courses })

  }
  componentDidMount() {
    FETCH.RegisteredCourses()
      .then(async response => {
        console.log(response)
        if (response.status === 'success') {
          if (response.data.length === 0)
            return this.setState({
              noCoursesRegistered: true,
              noCoursesMessage: response.message
            });
          await this.setState({
            courses: groupCoursesToSems(response.data),
            print_url: response.print_url
          });
        } else {
          this.setState({
            networkError: true,
            noCoursesMessage: response.message
          });
        }
      })
      .catch(err => console.log(err));
  }

  getTotalUnits = () => {
    let { courses, semester } = this.state;
    let totalUnit = courses[semester].reduce((totalScore, course) => {
      return parseInt(course.course_unit) + totalScore;
    }, 0);
    return totalUnit;
  };
  render() {
    let { courses, semester, networkError, noCoursesMessage } = this.state;
    console.log(courses)
    return networkError ? (
      <NoCourses message={noCoursesMessage} />
    ) : courses ? (
      <Fragment>
        {/* main content area */}
        <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
          <h1>Registered Courses</h1>
          {/* card for registered courses display  */}
          <div className="row no-gutters">
            <div className="col-lg-12">
              <div className={`card ${courses[semester].length === 0 ? "" : 'min-h-1000'}`}>
                <div className="card-header">
                  <div className="row no-gutters">
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 pt-3">
                      My Courses
                    </div>
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-right">
                      <select
                        onChange={e => {
                          this.setState({ semester: e.target.value });
                        }}
                        className="short"
                      >
                        <option value="first">1st Semester</option>
                        <option value="second">2nd Semester</option>
                      </select>
                    </div>
                  </div>
                </div>
                {
                  courses[semester].length === 0 ? <div className="row no-gutters">

                    <div className="card-body">
                      <div className="dashboard-transaction-container text-center">
                        <div className="empty-card text-center mt-3">
                          <button className="circle-bg-width-80 circle-bg circle-bg-gray">
                            <img
                              src={require('../assets/empty-fee.svg')}
                              className="svg"
                              alt="Min Unit"
                            />
                          </button>
                          <Fragment>
                            <p>You have not registered any courses for this semester</p>
                          </Fragment>
                        </div>
                      </div>
                    </div>
                  </div> :
                    <div className="card-body p-0 m-0">
                      <div className="table-responsive">
                        <table className="table">
                          <thead>
                            <tr>
                              <th scope="col" width={50} className="pl-41">
                                Code
                          </th>
                              <th scope="col" width={400}>
                                Course Title
                          </th>
                              <th scope="col" width={60}>
                                Unit
                          </th>
                              <th scope="col" width={60}>
                                Status
                          </th>
                              <th scope="col" width={180}>
                                Action
                          </th>
                            </tr>
                          </thead>
                          <tbody>
                            {courses[semester].length ? courses[semester] &&
                              courses[semester].map(course => (
                                <RegisteredCourse
                                  key={course.course_id}
                                  removeCourse={this.removeCourse}
                                  title={course.course_title}
                                  unit={course.course_unit}
                                  code={course.course_code}
                                  status={course.course_status}
                                  id={course.course_id}
                                />
                              )) : null
                            }
                          </tbody>

                        </table>
                      </div>
                    </div>
                }

                {courses[semester].length ? <div className="card-footer bg-transparent">
                  <div className="row no-gutters">
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                      {/* remove active class to disable */}
                      <div className="courses-selected active">
                        {courses[semester].length} Total courses registered
                      </div>
                    </div>
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-right">
                      {/* remove active class to disable */}
                      <span className="units-selected active">
                        {this.getTotalUnits()} unit(s)
                      </span>
                      {/* subtitute active class for disabled to either make button active or inactive */}
                      <a
                        href={`${this.state.print_url}/${semester}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary-big btn-border-radius-course active"
                      >
                        Print Course Form
                      </a>
                    </div>
                  </div>
                </div> : null}
              </div>
              {/* card for outstanding fees */}
            </div>
          </div>
          {/* end card for news display   */}
        </main>
        {/* main content area */}
      </Fragment >
    ) : (
          <RegisterCoursesLoader input={false} />
        );
  }
}

class RegisteredCourse extends Component {
  state = {
    loading: false
  }

  deleteCourse = id => {
    let { removeCourse } = this.props, {loading} = this.state;
    this.setState({ loading: true })
    FETCH.deleteCourse(id).then(res => {
      this.setState({ loading: false })
      removeCourse(id)
    }).catch(err => {
      this.setState({ loading: false })
      console.log(err)
    })

  }


  render() {
    let { title, unit, status, id, code } = this.props, { loading } = this.state;

    return (
      <tr>
        <td className="pl-41">{code}</td>
        <td>{title}</td>
        <td>{unit}</td>
        <td>{status}</td>
        <td className="p-28-0">
          <Link
            to={`/course/details/${id}`}
            className="btn course-action-btn active"
          >
            View
          </Link>
          <button onClick={() => { this.deleteCourse(id) }} className="btn course-action-btn active">{loading ? <i className="fas fa-circle-notch fa-spin" />: 'Delete'}</button>
        </td>
      </tr>
    )
  }

}

const NoCourses = ({ message }) => (
  <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
    <h1>Registered Courses</h1>
    <div className="row no-gutters">
      <div className="col-lg-12 m-auto">
        <div className="card ">
          <div className="card-body">
            <div className="dashboard-transaction-container text-center">
              <div className="empty-card text-center mt-3">
                <button className="circle-bg-width-80 circle-bg circle-bg-gray">
                  <img
                    src={require('../assets/empty-fee.svg')}
                    className="svg"
                    alt="Min Unit"
                  />
                </button>

                <Fragment>
                  <p>{message ? message : 'Server could not be reached'}</p>
                  {!message ? (
                    <small>
                      Could not get your registered courses, try again later
                    </small>
                  ) : null}
                </Fragment>
              </div>
              <Fragment>
                <Link
                  className="btn btn-primary btn-primary-color  mt-5"
                  to="/courses"
                >
                  Register courses
                </Link>
              </Fragment>
            </div>
          </div>
        </div>
        {/* card for outstanding fees */}
      </div>
    </div>

    {/* end card for news display   */}
  </main>
);

export default RegisteredCourses;
